import { Snackbar, Alert, Stack, Button, Typography, Box } from "@mui/material";
import { useSocketContext } from "./SocketProvider.hooks";
import { red } from "@mui/material/colors";

export const OrderNotificationSnackbarListener = () => {
    const { order_notifications, playNotificationSound, onClearOrderNotification } = useSocketContext();

    const handleAction = (order_uuid: string, action: "accept" | "reject") => {
        console.log(`Order ${action}:`, order_uuid);
        // remove from notifications
        onClearOrderNotification(order_uuid);
    };

    console.log("order_notifications =>", order_notifications);
    
    return (
        <Box
            sx={{
                position: "fixed",
                top: 16,
                right: 16,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                zIndex: 9999,
            }}
        >
            {order_notifications.map((order) => (
                <Alert
                    key={order.order_uuid}
                    variant="outlined"
                    icon={false}
                    sx={{
                        width: "100%",
                        borderRadius: 3,
                        boxShadow: "0px 4px 18px rgba(0,0,0,0.15)",
                        background: "rgba(255,255,255,0.85)",
                        backdropFilter: "blur(8px)",
                        border: "1px solid #d6eadd",
                        animation: "fadeIn 0.3s ease-out",
                        "@keyframes fadeIn": {
                            from: { opacity: 0, transform: "translateY(-8px)" },
                            to: { opacity: 1, transform: "translateY(0)" }
                        }
                    }}
                >
                    <Stack direction="row" justifyItems={"flex-start"} gap={1.5} >

                        {/* Icon + Title */}
                        <Stack direction="row" alignItems="center" gap={1}>
                            <Box
                                sx={{
                                    width: 38,
                                    height: 38,
                                    borderRadius: "12px",
                                    background: "linear-gradient(135deg, #686868, #303030)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "white",
                                    fontSize: "30px",
                                    fontWeight: 700,
                                }}
                            >
                                🧾
                            </Box>

                            <Box>
                                <Typography fontWeight={700} fontSize="15px" color="#1b5e20">
                                    New Order Received
                                </Typography>
                                <Typography fontSize="13px" color="#4a4a4a">
                                    Order #{order.order_number}
                                </Typography>
                            </Box>

                            {/* Buttons */}
                            <Stack direction="row" gap={1} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        height: 38,
                                        width: 80,
                                        borderRadius: "10px",
                                        textTransform: "none",
                                        borderColor: "#c8c8c8",
                                        color: "#666",
                                        "&:hover": {
                                            borderColor: "#999",
                                            background: "#f1f1f1",
                                        },
                                    }}
                                    onClick={() => handleAction(order.order_uuid as string, "reject")}
                                >
                                    Reject
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        height: 38,
                                        width: 80,
                                        borderRadius: "10px",
                                        textTransform: "none",
                                        background: "linear-gradient(135deg, #43A047, #66BB6A)",
                                        color: "#fff",
                                        fontWeight: 600,
                                        "&:hover": {
                                            background: "linear-gradient(135deg, #388E3C, #57A75A)",
                                        },
                                    }}
                                    onClick={() => handleAction(order.order_uuid as string, "accept")}
                                >
                                    Accept
                                </Button>

                                {/* <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    borderRadius: 2,
                                    width: 80,
                                    textTransform: "none",
                                }}
                                onClick={playNotificationSound}
                            >
                                Test Sound
                            </Button> */}
                            </Stack>
                        </Stack>
                    </Stack>
                </Alert>
            ))}
        </Box>

    );
};
